import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import getFieldId from '../../utils/get-field-id.js';

var useFieldId = function useFieldId(id, sequentialId) {
  var _React$useState = React__default.useState(id),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      internalId = _React$useState2[0],
      setId = _React$useState2[1];
  React__default.useEffect(function () {
    setId(getFieldId({
      id: id
    }, {
      id: internalId
    }, sequentialId));
  }, [id, internalId, setId, sequentialId]);
  return internalId;
};

export default useFieldId;
//# sourceMappingURL=use-field-id.js.map
